import { FC } from 'react'

type FormFieldsetProps = {
  className?: string
}

const FormFieldset:FC<FormFieldsetProps> = ({ children, className = ''}) => <fieldset className={`col-12 lg:col-5 lg:offset-1 ${className}`}>{children}</fieldset>

export { FormFieldset }